export const MFAQ_LABEL = "MFAQ";

export const otherLocationsList = [
  {
    value: "AsIs",
    transKey: "otherAreaAsIsString",
  },
  {
    value: "Bistro",
    transKey: "otherAreaBistroString",
  },
  {
    value: "Checkout",
    transKey: "otherAreaCheckoutString",
  },
  {
    value: "Click and Collect",
    transKey: "otherAreaClickAndCollectString",
  },
  {
    value: "Customer service area",
    transKey: "otherAreaCustomerServiceAreaString",
  },
  {
    value: "Entrance (Incl. Greeter)",
    transKey: "otherAreaEntranceInclGreeterString",
  },
  {
    value: "Financing area",
    transKey: "otherAreaFinancingAreaString",
  },
  {
    value: "First room",
    transKey: "otherAreaFirstRoomString",
  },
  {
    value: "Full Serve Handout",
    transKey: "otherAreaFullServeHandoutsString",
  },
  {
    value: "Home Service Point – Planning studio",
    transKey: "otherAreaHomeServicePointPlanningStudioString",
  },
  {
    value: "IKEA for Business",
    transKey: "otherAreaIKEAForBusinessString",
  },
  {
    value: "IKEA Restaurant",
    transKey: "otherAreaIKEARestaurantString",
  },
  {
    value: "Ingka Centers",
    transKey: "otherAreaIngkaCentersString",
  },
  {
    value: "Open the wallet Markethall",
    transKey: "otherAreaOpenTheWalletMarkethallString",
  },
  {
    value: "Open the wallet Showroom",
    transKey: "otherAreaOpenTheWalletShowroomString",
  },
  {
    value: "Parking zone",
    transKey: "otherAreaParkingZoneString",
  },
  {
    value: "Pick-up point/hub",
    transKey: "otherAreaPickUpPointHubString",
  },
  {
    value: "Questions from co-workers",
    transKey: "otherAreaQuestionsFromCoWorkersString",
  },
  {
    value: "Restaurant",
    transKey: "otherAreaRestaurantString",
  },
  {
    value: "Self-serve",
    transKey: "otherAreaSelfServeString",
  },
  {
    value: "Småland",
    transKey: "otherAreaSmalandString",
  },
  {
    value: "Swedish Food Market",
    transKey: "otherAreaSwedishFoodMarketString",
  },
];
